module.exports = __webpack_public_path__ + "img/blend4icon4.6f3415f5.png";